import React from "react";

import { useTranslation, Trans } from 'react-i18next';

import { withRouter } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import CardBody from "components/Card/CardBody";
import { Grid } from "@material-ui/core";
import DigitalIdCard from "./DigitalIdCard";

function DigitalIdDetail(props) {
    const { t } = useTranslation();
    const isWebView = function () { 
        if (typeof window === undefined) { return false };
            let navigator = window.navigator;

            const standalone = navigator.standalone;
            const userAgent = navigator.userAgent.toLowerCase();
            const safari = /safari/.test(userAgent);
            const ios = /iphone|ipod|ipad|macintosh/.test(userAgent);
            const ios_ipad_webview = ios && !safari;
        
            return ios ? ( (!standalone && !safari) || ios_ipad_webview ) : userAgent.includes('wv');
        }
    return (
        <GridContainer justify="center" className="paddingBottom64">
            <GridItem xs={12} sm={12} md={12}>
                <CardBody>
                    <Grid className="paddingLeftRight64" item xs={12} sm={12} md={12}>
                        <div className={"semibold-h400 paddingTop64 paddingTop40Mobile"}> {t("DigitalIdentityDetail_Title")}</div>
                        <Grid item xs={12} sm={12} md={6} className="paddingTop64 paddingTop40Mobile regular-b300s">
                        <Trans i18nKey="DigitalIdentityDetail_Subtitle" components={{ bold: <b /> }}></Trans>
                        </Grid>
                    </Grid>
                    <Grid className="paddingLeftRight64 paddingTop64 paddingTop40Mobile" item xs={12} sm={12} md={12}>
                        <div className="flexWrapper equals">
                            <div>
                                <div className="semibold-h200">{t("DigitalIdentityDetail_Section1_Title")}</div>
                            </div>
                            <div>
                                <DigitalIdCard userData={props.userData}></DigitalIdCard>
                                {/* <div className="regular-b300 paddingBottom24">{t("DigitalIdentityDetail_Section1_Description1")}</div>
                                <div className="regular-b300 paddingBottom12">{t("DigitalIdentityDetail_Section1_Description2")}</div>
                                <div className="paddingBottom24">
                                    <a className='semibold-b300 anchor'
                                            onClick={() => { window.open('https://alumni.iese.edu/page/qa-y-ayuda', '_blank') }}>
                                            <img loading="lazy"
                                                className="gotopageimgright gotopageimgblack"
                                                alt="GoToPage" src="/img/gotopage.svg" />{t("DigitalIdentityDetail_Section1_Description2_action")}</a>
                                </div>
                                <div className="regular-b300 paddingBottom24">{<><Trans i18nKey="DigitalIdentityDetail_Section1_Description3" components={{ bold: <b /> }} /></>}</div>
                                <div className="regular-b300">{t("DigitalIdentityDetail_Section1_Description4")}</div> */}
                            </div>
                        </div>
                    </Grid>
                    <hr className="customHr marginLeftRight64 paddingLeftRight64 customHrWidthLeftRightMobile" />
                    <Grid className="paddingLeftRight64" item xs={12} sm={12} md={12}>
                        <div className="flexWrapper equals">
                            <div>
                                <div className="semibold-h200">{t("DigitalIdentityDetail_Section2_Title")}</div>
                            </div>
                            <div>
                                <div className="regular-b300 paddingBottom24">{t("DigitalIdentityDetail_Section2_Description1")}</div>
                                <div className="semibold-b300 paddingBottom24">{t("DigitalIdentityDetail_Section2_Description2")}</div>
                                <div className="regular-b300 paddingBottom24">{<><Trans i18nKey="DigitalIdentityDetail_Section2_Description3" components={{ bold: <b /> }} /></>}</div>
                                <div className="regular-b300 paddingBottom12">{t("DigitalIdentityDetail_Section2_Description4")}</div>
                                <div className="">
                                    <a className='semibold-b300 anchor'
                                            onClick={() => { window.open('https://alumni.iese.edu/page/qa-y-ayuda', '_blank') }}>
                                            <img loading="lazy"
                                                className="gotopageimgright gotopageimgblack"
                                                alt="GoToPage" src="/img/gotopage.svg" />{t("DigitalIdentityDetail_Section1_Description2_action")}</a>
                                </div>
                            </div>
                        </div>
                    </Grid>
                    <hr className="customHr marginLeftRight64 paddingLeftRight64 customHrWidthLeftRightMobile" />
                    <Grid className="paddingLeftRight64" item xs={12} sm={12} md={12}>
                        <div className="flexWrapper equals">
                            <div>
                                <div className="semibold-h200">{t("DigitalIdentityDetail_Section3_Title")}</div>
                            </div>
                            <div>
                                <div className="regular-b300 paddingBottom12">{t("DigitalIdentityDetail_Section3_Description1")}</div>
                                <div className="paddingBottom24">
                                    <a className='semibold-b300 anchor'
                                            onClick={() => { window.open(t("PersonalInformation_AgreeTermsOfUseUrl"), '_blank') }}>
                                            <img loading="lazy"
                                                className="gotopageimgright gotopageimgblack"
                                                alt="GoToPage" src="/img/gotopage.svg" />{t("DigitalIdentityDetail_Section3_Description1_action")}</a>
                                </div>
                                <div className="regular-b300 paddingBottom12">{t("DigitalIdentityDetail_Section3_Description2")}</div>
                                <div className="paddingBottom24">
                                    <a className='semibold-b300 anchor'
                                            onClick={() => { window.open(t("PersonalInformation_AgreeTermsPrivacyUrl"), '_blank') }}>
                                            <img loading="lazy"
                                                className="gotopageimgright gotopageimgblack"
                                                alt="GoToPage" src="/img/gotopage.svg" />{t("DigitalIdentityDetail_Section3_Description2_action")}</a>
                                </div>
                                <div className="regular-b300 paddingBottom12">{<><Trans i18nKey="DigitalIdentityDetail_Section3_Description3" components={{ bold: <b /> }} /></>}</div>
                                <div className="paddingBottom24">
                                    <a className='semibold-b300 anchor' href='mailto:SeguridadBCN@iese.edu' target={isWebView ? '_self' : '_blank'} rel='noreferrer'
                                            // onClick={() => { window.open('mailto:SeguridadBCN@iese.edu', isWebView ? '_self' : '_blank') }}
                                            >
                                            <img loading="lazy"
                                                className="gotopageimgright gotopageimgblack"
                                                alt="GoToPage" src="/img/gotopage.svg" />{t("DigitalIdentityDetail_Section3_Description3_action")}</a>
                                </div>
                                <div className="regular-b300 paddingBottom12">{<><Trans i18nKey="DigitalIdentityDetail_Section3_Description4" components={{ bold: <b /> }} /></>}</div>
                                <div className="">
                                    <a className='semibold-b300 anchor'
                                            onClick={() => { window.open(t("DigitalIdentityDetail_Section3_Description4_action_uri"), '_blank') }}>
                                            <img loading="lazy"
                                                className="gotopageimgright gotopageimgblack"
                                                alt="GoToPage" src="/img/gotopage.svg" />{t("DigitalIdentityDetail_Section3_Description4_action")}</a>
                                </div>
                            </div>
                        </div>
                    </Grid>
                </CardBody>
            </GridItem>
        </GridContainer>
    );
}
export default withRouter(DigitalIdDetail);